export default __webpack_public_path__ + "static/media/pic6.9c2985c8.jpg";